/**
 * CMS Service
 */
import { getApiClient } from '../apiClient';
import { CMS_ENDPOINTS } from '../endpoints';
import type {
  GetCmsResponse,
  UpdateCmsPayload,
  UpdateCmsResponse,
} from '../types/cms.types';

export const cmsService = {
  /**
   * Get CMS data
   */
  getCms: (): Promise<GetCmsResponse> => {
    return getApiClient().get(CMS_ENDPOINTS.getCms);
  },

  /**
   * Update CMS data
   */
  updateCms: (body: UpdateCmsPayload): Promise<UpdateCmsResponse> => {
    return getApiClient().put(CMS_ENDPOINTS.updateCms, body);
  },
};

